module.exports = __webpack_public_path__ + "static/media/Leccion-11-26-Conquistando-el-Caracter-de-Cristo.6a254b4d.pdf";